import axios from "../axios"

const getExpertPurposeTypeCategories = () => {
    return axios.get('/docflow/purpose-categories')
        .then(response => response.data);
}

export default {
    getExpertPurposeTypeCategories
}
